import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-active-tour',
  templateUrl: './active-tour.component.html',
  styleUrls: ['./active-tour.component.scss']
})
export class ActiveTourComponent implements OnInit {
  id: string = "";
  constructor(private route: ActivatedRoute){
    
  }

  ngOnInit(): void {
    this.route.paramMap
    .subscribe(params => {
      this.id = params.get("id")??"";
    })
  }
}
